import * as React from 'react';

import Routing from './Routing';

import styles from './RouteContent.scss';

const RouteContent = () => {
    return (
        <section className={styles.section}>
            <div id={'router-main-app'}>
                <Routing />
            </div>
        </section>
    );
};

export default RouteContent;
